export const getBackendUrl = (): string => {
  const storedBackendUrl = sessionStorage.getItem('backendUrl');
  
  if (storedBackendUrl) {
    return storedBackendUrl;
  }
  
  // Use environment variable or fallback to localhost
  return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8787';
};
